import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { PanelContainer } from '../../../panels/panelStyles';
import { PANEL_CONTENT_PADDING_STRING } from '../../../styles/styles';
import { PokerRoomInfoSubPanel } from './pokerRoomInfoSubPanel';
export const PokerRoomInfoPanel = () => {
    return (_jsx(PanelContainer, { padding: PANEL_CONTENT_PADDING_STRING, "aria-label": 'poker room info panel', children: _jsx(PokerRoomInfoSubPanel, {}) }));
};
